var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGemini({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 2l2.8 6.3L22 11l-7.2 2.7L12 20l-2.8-6.3L2 11l7.2-2.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGemini);
export default __webpack_public_path__ + "static/media/gemini.fe4c3fbebeae6aa5031a64561fdfbed3.svg";
export { ForwardRef as ReactComponent };